import '../../assets/css/common/button.css';
import { recordButtonClick } from '../../configs/rum';

const Button = (props) => {
    const { text, className, onClick, disabled, children, type } = props;

    const handleClickButton = (event) => {
        if (!disabled) {
            if (onClick) {
                onClick();
            }

            // RUM ボタン押下ログ（DOM要素と text を渡すだけ。ラベル解決は rum.js 側）
            recordButtonClick(event.currentTarget, text);
        }
    };

    return (
        <button type={type} onClick={handleClickButton} className={className}>
            {text != null ? text : children}
        </button>
    );
};

export default Button;
